import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    supportedLngs: ['pt-BR', 'en'],
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    ns: ['common'],
    detection: {
      order: ['path', 'cookie', 'htmlTag', 'localStorage', 'subdomain'],
      caches: ['cookie'],
    },
    backend: {
      loadPath:
        'https://d2u4nr6hjrsi1m.cloudfront.net/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: false,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i', 'p'],
    },
  });

export default i18n;
